import { MATERIALS_ORDER_TOPIC } from '@/components/Tickets/materialsOrderSelection';
import { isAwaitingConfirmation } from '@/utils/ticketStates';

const LINE_BREAK = '\n';
const NOTE_SEPARATOR = '\n\nNota: ';
const ITEM_LINE_PATTERN = /^- (.+): (\d+) (.+)$/;
const URL_PATH_PATTERN = /^[a-z][a-z0-9+.-]*:\/\/[^/?#]*([^?#]*)/i;
const IMAGE_PATH_PATTERN = /\.(jpe?g|png|webp|gif)$/i;
const CALENDAR_DAY_PATTERN = /^(\d{4}-\d{2}-\d{2})/;
const NO_DELIVERY_DAY = '';
const DELIVERY_DAY_NOON = 'T12:00:00';
const DATE_LOCALE = 'es-PE';
const DELIVERY_DAY_FORMAT = { dateStyle: 'long' };

export function isMaterialsOrderAwaitingConfirmation(ticket) {
  return ticket.topic === MATERIALS_ORDER_TOPIC && isAwaitingConfirmation(ticket.estado);
}

function parseItemLine(line) {
  const match = ITEM_LINE_PATTERN.exec(line.trim());

  return match ? { name: match[1], quantity: Number(match[2]), unit: match[3] } : null;
}

function splitNote(text) {
  const noteStart = text.indexOf(NOTE_SEPARATOR);
  if (noteStart === -1) return { body: text, note: '' };

  return { body: text.slice(0, noteStart), note: text.slice(noteStart + NOTE_SEPARATOR.length).trim() };
}

export function parseMaterialsOrderDescription(description) {
  const text = description || '';
  const { body, note } = splitNote(text);
  const items = body.split(LINE_BREAK).map(parseItemLine).filter(Boolean);

  return items.length ? { items, note, rawText: '' } : { items: [], note: '', rawText: text.trim() };
}

export function isImageEvidence(url) {
  const match = typeof url === 'string' ? URL_PATH_PATTERN.exec(url) : null;

  return Boolean(match) && IMAGE_PATH_PATTERN.test(match[1]);
}

export function formatDeliveryDay(day) {
  const match = typeof day === 'string' ? CALENDAR_DAY_PATTERN.exec(day) : null;
  if (!match) return NO_DELIVERY_DAY;

  const deliveryDate = new Date(`${match[1]}${DELIVERY_DAY_NOON}`);

  return Number.isNaN(deliveryDate.getTime())
    ? NO_DELIVERY_DAY
    : deliveryDate.toLocaleDateString(DATE_LOCALE, DELIVERY_DAY_FORMAT);
}
